import { baseUrl } from 'volto-ebc-radionacional/utils/api';

export type ProgramScheduleItem = {
  '@id'?: string;
  title: string;
  token: string;
  description?: string;
};

export async function getProgramsSchedule(): Promise<ProgramScheduleItem[]> {
  try {
    const response = await fetch(`${baseUrl}/@programs-schedule`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Erro ao buscar programas da grade: ${response.status}`);
    }

    const data = await response.json();

    if (!Array.isArray(data)) return [];

    return data
      .filter((item) => item?.title && item?.token)
      .sort((a, b) => a.title.localeCompare(b.title, 'pt-BR'));
  } catch (error) {
    console.error('Falha ao buscar descrições dos programas:', error);
    return [];
  }
}
